import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { OrderPayInfoPage } from "./OrderPayInfoPage";

export const orderPayInfo = typeCheckAppModule({
    NAME,
    Container: OrderPayInfoPage,
    route: Routes.orderPayInfo,
});
